import { FooterLogo, MedLogo } from "./Icons";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  Twitter,
  YoutubeIcon,
} from "./SocialIcons";
import { useContent } from "../../i18n";
import "./style.scss";

export const Footer = () => {
  const { nav, footer } = useContent();

  return (
    <div className="footer-wrapper">
      <div className="container">
        <div className="footer-logo-copy">
          <div className="logos">
            <MedLogo />
            <FooterLogo />
          </div>
          <div className="copyrights">
            <p dir="ltr">
              ©{new Date().getFullYear()} {footer.rights}
            </p>
          </div>
        </div>

        <div className="footer-links">
          <div className="left-footer">
            <a href="#providers">{nav.providers}</a>
            <a href="#features">{nav.members}</a>
            <a href="#plans">{nav.plans}</a>
            <a href="#organizations">{nav.organizations}</a>
            <a href="#capabilities">{nav.capabilities}</a>
            <a href="#about">{nav.about}</a>
            <a href="#contact">{nav.contact}</a>
          </div>
          <div className="footer-icons">
            <a href="#">
              <FacebookIcon />
            </a>
            <a href="#">
              <LinkedinIcon />
            </a>
            <a href="#">
              <Twitter />
            </a>
            <a href="#">
              <YoutubeIcon />
            </a>
            <a href="#">
              <InstagramIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
